// Basic text style flags for quick emphasis selection
export enum BasicTextStyle {
  PLAIN = 'plain',
  BOLD = 'bold',
  ITALIC = 'italic',
  BOLD_ITALIC = 'bold-italic'
}
